import { createI18n } from "vue-i18n"
import en from "./locales/en/common.json"
import ru from "./locales/ru/common.json"
import type { LanguageCode } from "@lib/domain"

const fallback: LanguageCode = "en"
const locale: LanguageCode = "ru"

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: fallback,
  messages: { en, ru },
})
